import React, { use, useEffect, useState } from 'react';
import LinkViewCard from './LinkViewCard';
import './LinkView.css';
import AppNavbar from '../AppNavbar/AppNavbar';
import OTPVerification from './OTPVerification';
import { hideHeader } from '../../utils/helperFunctions';
import SuccessCard from './SuccessCard';
import AlertDialogue from './AlertDialogue';
import DotsLoader from '../Loader/DotsLoader/DotsLoader';
import { getApiData } from '../../api/api';
import AxiosRequest from '../../utils/axios';

const axios = new AxiosRequest().getClient()

const LinkView = () => {
    const [otpVerifcation, setOTPVerification] = useState(true);
    const [policies, setPolicies] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isAllpoliciesVerified, setIsAllpoliciesVerified] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [alertData, setAlertData] = useState({
        open: false,
        type: "",
        msg: "",
        actions: []
    });

    useEffect(() => {
        hideHeader();
    }, []);


    const handlePoliciesData = (data) => {
        setPolicies(data);
        setIsLoggedIn(true)
        if (data.length) {
            const verifiedPolicies = data.filter(policy => policy.journeyCompleted);
            setIsAllpoliciesVerified(verifiedPolicies.length === data.length);
        }
    };

    const redirectToLink = async (posvRefNumber) => {
       
        const { url, body } = getApiData("policySearch");
        body.request.payload.fromOsp = false;
        body.request.payload.policyStatus = false;
        body.request.payload.posvRefNumber = posvRefNumber;
        body.request.payload.sendPosvLink = 'Y';
        console.log({ url, body })
        try {
            setIsLoading(true);
            const response = await axios.post(url, body);
            if(response.data.response.payload.posvLinkToCustomer) {
                window.open(response.data.response.payload.posvLinkToCustomer, '_self');
            } else {
                setAlertData({
                    open: true,
                    type: "error",
                    msg: response.data.response.payload.businessMsg,
                    actions: []
                })
            }
            
            console.log({ response })
        } catch (error) {
            console.log("Error in fetching config-- REDIRECTION :: ", error);
            setAlertData({
                open: true,
                type: "error",
                msg: "Something went wrong. Please try again later.",
                actions: []
            })
        } finally {
            setIsLoading(false);
        }
    }


    const handleLogout = () => {
        console.log("Logout")
        setAlertData({
            open: true,
            type: "actionDialog",
            msg: "Are you sure you want to logout of the verification page?",
            actions: [
                {
                    actionText: "Yes,Logout",
                    action: () => {
                        setIsLoggedIn(false);
                        setOTPVerification(true);
                        setIsAllpoliciesVerified(false);
                        setPolicies([]);
                        setAlertData({
                            open: false,
                            type: "",
                            msg: "",
                            actions: [],
                        });
                    },
                    className: "secondaryBtn"
                },
                {
                    actionText: "No",
                    action: () => {
                        setAlertData({
                            open: false,
                            type: "",
                            msg: "",
                            actions: [],
                        });
                    },
                    className: "primaryBtn"
                }
            ]
        })
    }

    const getPendingPolicyCount = () => {
        return policies?.filter(policy => !policy.journeyCompleted).length;
    };


    const getComponent = () => {
        if (isAllpoliciesVerified) {
            return <SuccessCard mobileNumber={""} />
        }
        if (otpVerifcation) {
            return <OTPVerification redirectToLink={redirectToLink} setOTPVerification={setOTPVerification} handlePoliciesData={handlePoliciesData} />;
        }
        console.log({ policies })
        return (
            <div className='link-view-main-cntnr'>
                <div className='main-hding'>
                    {policies?.length > 1 && <p>
                        Pending POSV Verifications • {getPendingPolicyCount()}
                    </p>}
                </div>
                <div className='link-view-card-wrpr'>
                    {
                        policies.length > 0 && policies.map((policy, index) => (
                            <LinkViewCard redirectToLink={redirectToLink} key={index} policy={policy} setIsLoading={setIsLoading} />
                        ))
                    }
                </div>
            </div>
        );
    };

    return (
        <>
            <AppNavbar handleLogout={handleLogout} isLoggedIn={isLoggedIn} />
            {isLoading && <DotsLoader msg={"Please wait..."} />}
            {alertData.open && <AlertDialogue msg={alertData.msg} actions={alertData.actions} type={alertData.type} closeDialogue={
                () => setAlertData({
                    actions: [],
                    msg: "",
                    open: false,
                    type: ""
                })
            } />}
            {getComponent()}
        </>
    );
};

export default LinkView;